import { signal } from '@preact/signals';

var PluginName;
(function (PluginName) {
    PluginName["DragAndDrop"] = "dragAndDrop";
    PluginName["EventModal"] = "eventModal";
    PluginName["ScrollController"] = "scrollController";
    PluginName["EventRecurrence"] = "eventRecurrence";
    PluginName["Resize"] = "resize";
    PluginName["CalendarControls"] = "calendarControls";
    PluginName["Sidebar"] = "sidebar";
    PluginName["Header"] = "header";
})(PluginName || (PluginName = {}));

const createHeaderPlugin = () => {
    // const timeRange = signal<[Date, Date] | null>(null)
    // const profiles = signal<string[] | null>(null)
    // const sidebarAddresses = signal<string[] | null>(null)
    // const motives = signal<string[] | null>(null)
    return {
        name: PluginName.Header,
        textSwitchBtn: signal(''),
        // setIsOpen,/
        // timeRange,
        // profiles,
        // motives,
        // sidebarAddresses,
        // setAddresses: (
        //   addresses: string[],
        // ) => {
        //   sidebarAddresses.value = addresses
        // },
    };
};

export { createHeaderPlugin };
